module.exports = __webpack_public_path__ + "static/media/pharma_benefits_icon_active.8876e13c.svg";